const hasVisitedOnboarding = (): boolean => {
  const hasVisited = localStorage.getItem("hasVisitedOnboarding")
  if (hasVisited) return true

  localStorage.setItem("hasVisitedOnboarding", "true")
  return false
}

export default hasVisitedOnboarding
